import { useSnapshot } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { TelephonyCommandNames } from '../contract'
import { IconPlayerPause, IconPlayerPlay, IconLogout } from '../ui/icons'

const fmtDur = (s: number): string => {
  if (s <= 0) return '0s'
  if (s < 60) return `${s}s`
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

export function QueueDetailPanel() {
  const { queueMembers, agentStats } = useSnapshot()
  const run = useCommand()
  const statFor = (queue: string, agent: string) =>
    agentStats.find((s) => s.queue === queue && s.agent === agent)

  return (
    <div className="sb-panel">
      {queueMembers.length === 0 ? (
        <div className="sb-panel-empty">No queue members.</div>
      ) : (
        queueMembers.map((m) => {
          const st = statFor(m.queue, m.memberInterface)
          return (
            <div key={`${m.queue}/${m.memberInterface}`} className="card">
              <div className="row">
                <span>
                  <strong>{m.memberName || m.memberInterface}</strong>
                  <span className="faint"> · {m.queue}</span>
                  <span className="muted"> · {m.status.replace('_', ' ')}</span>
                </span>
                <span className="btnrow" style={{ marginTop: 0 }}>
                  <button className={m.paused ? 'btn btn-on' : 'btn'}
                    onClick={() => void run({
                      command: m.paused ? TelephonyCommandNames.QueueUnpause : TelephonyCommandNames.QueuePause,
                      params: { queue: m.queue, member_interface: m.memberInterface }
                    })}>
                    {m.paused ? <IconPlayerPlay size={14} stroke={1.75} /> : <IconPlayerPause size={14} stroke={1.75} />}
                    {m.paused ? 'unpause' : 'pause'}
                  </button>
                  <button className="btn"
                    onClick={() => void run({
                      command: TelephonyCommandNames.QueueLogout,
                      params: { queue: m.queue, member_interface: m.memberInterface }
                    })}>
                    <IconLogout size={14} stroke={1.75} /> log out
                  </button>
                </span>
              </div>
              {st ? (
                <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
                  answered {st.callsAnswered} · avg ring {st.avgRingSeconds}s · avg talk {fmtDur(st.avgCallSeconds)}
                </div>
              ) : null}
            </div>
          )
        })
      )}
      {queueMembers.length > 0 && agentStats.length === 0 ? (
        <div className="faint" style={{ marginTop: 8, fontSize: 11 }}>
          Per-agent stats bind to the contract’s agent_stats event; the engine emits it in a follow-up pass.
        </div>
      ) : null}
    </div>
  )
}
